import React, { memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { RenderIf, concatClasses } from '../../utils/fns'

import { globalAlertActions, selectGlobalAlert } from '../../utils/slices/alert.slice'

import SVGIcon from '../Common/SvgIcon'

const GlobalAlert = () => {
  const dispatch = useDispatch()
  const { level, icon, title, description } = useSelector(selectGlobalAlert)

  return RenderIf(
    description,
    <div className={concatClasses('globalMessage', level ? `-${level}` : '')}>
      <span
        className="globalMessage__close"
        onClick={() => dispatch(globalAlertActions.clearAlertMessage())}
      />

      <SVGIcon
        svgClasses="globalMessage__icon iconic-sm"
        src={icon ?? 'assets/images/iconic/info.svg'}
        alt="alert-icon"
      />

      <div className="globalMessage__text">
        {RenderIf(title, <div className="globalMessage__header">{title}</div>)}
        <div className="globalMessage__body">{description}</div>
      </div>
    </div>,
  )
}

export default memo(GlobalAlert)
